export function apply_setter_to_array(array, obj_id, setter) {
    return array.map((obj) => (obj.id === obj_id ? { ...obj, ...setter } : obj));
}
export function isNotOptimized(temp) {
    let is_all_null = true;
    for (let i = 0; i < 24; ++i) {
        for (let j = 1; j < 7; ++j) {
            if (temp[j][i] !== temp[j - 1][i]) {
                return false;
            }
            if (temp[j][i] !== 0)
                is_all_null = false;
        }
    }
    return !is_all_null;
}
